/**
 * Banners de financiación en la ficha de producto: Aplazo y MercadoPago.
 *
 * Hace dos cosas, ambas heredadas del tema 6.0.0:
 *
 *   1. Retocar el widget de Aplazo por dentro. Aplazo lo monta en un shadow DOM,
 *      así que su CSS no se puede alcanzar desde la hoja de estilos del tema y
 *      hay que inyectarlo elemento a elemento.
 *
 *   2. Alternar los dos banners cada 6 segundos, porque ocupan el mismo hueco.
 *
 * Respecto al 6.0.0 cambia una cosa importante: allí la espera del widget era
 * un requestAnimationFrame recursivo sin condición de salida, de modo que en
 * cualquier ficha sin Aplazo el navegador seguía ejecutándolo ~60 veces por
 * segundo indefinidamente. Aquí la espera está acotada.
 */
(() => {
  const ESPERA_MAXIMA_MS = 10000;
  const INTERVALO_ROTACION_MS = 6000;

  /**
   * Espera a que aparezca un elemento, rindiéndose pasado ESPERA_MAXIMA_MS.
   * @param {() => Element|null} buscar
   * @returns {Promise<Element|null>}
   */
  const esperarElemento = (buscar) =>
    new Promise((resolve) => {
      const encontrado = buscar();
      if (encontrado) {
        resolve(encontrado);
        return;
      }

      const limite = setTimeout(() => {
        observer.disconnect();
        resolve(null);
      }, ESPERA_MAXIMA_MS);

      const observer = new MutationObserver(() => {
        const el = buscar();
        if (!el) return;
        clearTimeout(limite);
        observer.disconnect();
        resolve(el);
      });

      observer.observe(document.body, { childList: true, subtree: true });
    });

  /** Recolorea el enlace «Conoce más» y ajusta el logo en móvil. */
  const estilarAplazo = (widget) => {
    if (!widget.shadowRoot) return;

    const enlace = widget.shadowRoot.querySelector('.info-trigger');
    if (enlace) enlace.style.setProperty('color', '#000000', 'important');

    const logo = widget.shadowRoot.querySelector('aplazo-logo');
    if (logo && logo.shadowRoot && !logo.shadowRoot.querySelector('#custom-logo-style')) {
      const estilo = document.createElement('style');
      estilo.id = 'custom-logo-style';
      estilo.textContent = `
        @container contenedor-producto (max-width: 490px) {
          img {
            height: 16px !important;
            top: 4px !important;
          }
        }
      `;
      logo.shadowRoot.appendChild(estilo);
    }

    widget.classList.add('aplazo-ready');
  };

  const iniciarAplazo = async () => {
    const widget = await esperarElemento(
      () => {
        const el = document.querySelector('aplazo-placement');
        return el && el.shadowRoot ? el : null;
      }
    );
    if (!widget) return;

    estilarAplazo(widget);

    // Aplazo vuelve a pintar su contenido al cambiar de variante, y al hacerlo
    // se lleva por delante los retoques. Por eso hay que reaplicarlos.
    const observer = new MutationObserver(() => estilarAplazo(widget));
    observer.observe(widget.shadowRoot, { childList: true, subtree: true });
  };

  const iniciarRotacion = async () => {
    const aplazo = await esperarElemento(() =>
      document.querySelector('div[id*="aplazo_banner_product_banner"]')
    );
    if (!aplazo) return;

    const mercadoPago = document.querySelector('div[id*="mercado_pago_banner_tooltips_credits"]');
    if (!mercadoPago) return;

    let mostrandoAplazo = true;
    mercadoPago.style.display = 'none';

    setInterval(() => {
      mostrandoAplazo = !mostrandoAplazo;
      aplazo.style.display = mostrandoAplazo ? '' : 'none';
      mercadoPago.style.display = mostrandoAplazo ? 'none' : '';
    }, INTERVALO_ROTACION_MS);
  };

  const iniciar = () => {
    iniciarAplazo();
    iniciarRotacion();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();
